import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { AppGlobalStateContext } from '../context/AppContext';
import { SNIFFSPOT_LOGO_URL } from '../utils/constants';

function Header({ currentPage, setCurrentPage, availableSpots, gateCode }) {
    const { userDetails, logout } = useAuth();
    const { 
        pendingBookingsCount, 
        userPendingBookingsCount, 
        userApprovedBookingsCount, 
        handleDownloadMyBookingsPdf, 
        pendingRequestsCount 
    } = useContext(AppGlobalStateContext);

    const handleDownloadClick = () => {
        if (userApprovedBookingsCount === 0) return;
        handleDownloadMyBookingsPdf();
    };
    
    const getDownloadButtonTitle = () => {
        return userApprovedBookingsCount === 0 ? "You have no approved bookings to download." : "";
    };

    return (
        <header className="bg-gradient-to-r from-emerald-500 to-sky-600 text-white p-4 shadow-lg no-print">
            <div className="container mx-auto flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0">
                <a href="https://www.facebook.com/share/1J3QJquGUS/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="cursor-pointer hover:opacity-80 transition duration-300">
                    <img
                        src={SNIFFSPOT_LOGO_URL}
                        alt="Shep's Sniff Spot Logo"
                        className="h-10 w-auto"
                        onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/192x64/000/FFF?text=Sniffspot"; }}
                    />
                </a>
                <nav className="flex flex-wrap justify-center sm:justify-start items-center gap-2">
                    {/* Website Link Button */}
                    <Link 
                        to="/" 
                        className="px-4 py-2 rounded-full text-sm font-semibold transition duration-300 ease-in-out hover:bg-emerald-400 hover:bg-opacity-80 border border-emerald-300/50 bg-emerald-600/20"
                    >
                        ← Website
                    </Link>

                    <button onClick={() => setCurrentPage('book')} className={`px-4 py-2 rounded-full text-sm font-semibold transition duration-300 ease-in-out relative ${currentPage === 'book' ? 'bg-white text-emerald-700 shadow-md' : 'hover:bg-emerald-400 hover:bg-opacity-80'}`}>
                        Book a Spot
                        {!userDetails?.isAdmin && typeof availableSpots !== 'undefined' && (
                            <span className="absolute top-0 right-0 -mt-1 -mr-1 px-2 py-1 text-xs font-bold bg-blue-500 text-white rounded-full animate-pulse">{availableSpots}</span>
                        )}
                    </button>
                    <button onClick={() => setCurrentPage('schedule')} className={`px-4 py-2 rounded-full text-sm font-semibold transition duration-300 ease-in-out ${currentPage === 'schedule' ? 'bg-white text-emerald-700 shadow-md' : 'hover:bg-emerald-400 hover:bg-opacity-80'}`}>
                        Weekly Schedule
                    </button>
                    <button onClick={() => setCurrentPage('profile')} className={`px-4 py-2 rounded-full text-sm font-semibold transition duration-300 ease-in-out relative ${currentPage === 'profile' ? 'bg-white text-emerald-700 shadow-md' : 'hover:bg-emerald-400 hover:bg-opacity-80'}`}>
                        Profile
                    </button>
                    <button onClick={() => setCurrentPage('packages')} className={`px-4 py-2 rounded-full text-sm font-semibold transition duration-300 ease-in-out relative ${currentPage === 'packages' ? 'bg-white text-emerald-700 shadow-md' : 'hover:bg-emerald-400 hover:bg-opacity-80'}`}>
                        Packages
                    </button>
                    
                    {/* --- SHOP BUTTON IS GONE FROM HERE --- */}

                    <button onClick={() => setCurrentPage('forms')} className={`px-4 py-2 rounded-full text-sm font-semibold transition duration-300 ease-in-out relative ${currentPage === 'forms' ? 'bg-white text-emerald-700 shadow-md' : 'hover:bg-emerald-400 hover:bg-opacity-80'}`}>
                       Forms & Information
                    </button>
                    {userDetails && (
                        <button
                            onClick={handleDownloadClick}
                            title={getDownloadButtonTitle()}
                            disabled={userApprovedBookingsCount === 0}
                            className={`px-4 py-2 rounded-full text-sm font-semibold transition duration-300 ease-in-out relative hover:bg-emerald-400 hover:bg-opacity-80 ${userApprovedBookingsCount === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
                        >
                            Download My Bookings
                            {userPendingBookingsCount > 0 && (
                                <span className="absolute top-0 right-0 -mt-1 -mr-1 px-2 py-1 text-xs font-bold bg-yellow-500 text-yellow-900 rounded-full">
                                    {userPendingBookingsCount}
                                </span>
                            )}
                        </button>
                    )}
                    {userDetails?.isAdmin && (
                        <button onClick={() => setCurrentPage('blockDates')} className={`px-4 py-2 rounded-full text-sm font-semibold transition duration-300 ease-in-out relative ${currentPage === 'blockDates' ? 'bg-white text-emerald-700 shadow-md' : 'hover:bg-emerald-400 hover:bg-opacity-80'}`}>
                            Admin
                        </button>
                    )}
                </nav>
                
                {userDetails?.isAdmin && (pendingBookingsCount > 0 || pendingRequestsCount > 0) && (
                    <div className="w-full mt-4 p-2 bg-white text-center font-bold shadow-xl border border-red-300 rounded">
                        <div className="text-sm font-normal text-gray-800 flex flex-col sm:flex-row justify-center sm:space-x-6 space-y-1 sm:space-y-0">
                            {pendingBookingsCount > 0 && <span className="block p-0.5">Spot Requests: <span className="font-extrabold text-red-600">{pendingBookingsCount}</span></span>}
                            {pendingRequestsCount > 0 && <span className="block p-0.5">Package Requests: <span className="font-extrabold text-red-600">{pendingRequestsCount}</span></span>}
                        </div>
                    </div>
                )}
                
                <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4 mt-3 sm:mt-0">
                    {userDetails && !userDetails.isAnonymous && (
                        <div className="flex flex-wrap items-center justify-center space-x-2 text-center sm:text-left">
                            <span className="text-lg font-bold">Welcome, <span style={{ color: userDetails.color }}> {userDetails.displayName || userDetails.email}</span> !</span>
                            {userDetails.isAdmin && <span className="px-2 py-1 bg-yellow-400 text-yellow-900 text-xs font-bold rounded-full">Admin</span>}
                            {gateCode && !userDetails.isGateCodeBlocked && (
                                <span className="mt-1 sm:mt-0 px-3 py-1 bg-white text-green-700 text-sm font-extrabold rounded-full shadow-lg" title="Gate Combination Lock Code">
                                   ♡ Gate Code: ♡ {gateCode} ♡
                                </span>
                            )}
                        </div>
                    )}
                    <button onClick={logout} className="px-4 py-2 bg-red-500 text-white rounded-full text-sm font-semibold hover:bg-red-600 transition duration-300 ease-in-out shadow-md w-full sm:w-auto">Logout</button>
                </div>
            </div>
        </header>
    );
}

export default Header;